import {Injectable} from '@angular/core';

import {LoginService} from '../../shared/services/login.service';
import {HttpClient} from '@angular/common/http';
import {FileUploadService} from '../../shared/services/file-upload.service';
import {ServiceBase} from '../../shared/services/service-base';
import {LndW} from './lnd-w';
import {WorkrequestLndWViewmodel} from './workrequest-lnd-w-viewmodel';
import {LndBaseService} from './lnd-base.service';

@Injectable()
export class LndWService extends LndBaseService<LndW> {
  formalPlanOfSubdivision: boolean;
  overallDevelopmentPlan: boolean;
  planIndicatingServiceLayout: boolean;

  constructor(protected http: HttpClient, protected loginService: LoginService, protected fileUploadService: FileUploadService) {
    super(http, loginService, fileUploadService);
    const me = this;
    this.loginService.onLogout.subscribe((next: any) => {
        me.initializeData();
      },
      (error: any) => {
        me.initializeData();
      }
    );
    this.initializeData();
  }

  get submitUrl(): string {
    return LndWService.submitUrl;
  }

  static get submitUrl(): string {
    return ServiceBase.baseHref + '/api/submitLndWApplication';
  }

  initWorkRequestViewModel() {
    this.applicationData = new LndW();
    this.workRequestViewModel = new WorkrequestLndWViewmodel();
    (<LndW>this.applicationData).workrequestDetails = (<WorkrequestLndWViewmodel>this.workRequestViewModel).workrequestDetails;
  }

  initUploadFileCustomData() {
    this.formalPlanOfSubdivision = false;
    this.overallDevelopmentPlan = false;
    this.planIndicatingServiceLayout = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/lnd-w-form/lnd-w.service.ts